<template>
    <div class="establishment">
        <div class="establishment__inner body">
            <div class="establishment__desc">
                <p class="establishment__title">
                    Need more information?
                </p>
                <p class="establishment__txt">
                    Contact us at <a :href="`mailto:${$contact}`" class="txt--purple">{{ $contact }}</a>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'Establishment',
};
</script>
